import { VehicleCard as SharedVehicleCard } from '@cinch-nx/landing-ui-shared'
import {
  EventNames,
  TrackingEventTypes,
  useAnalytics,
} from '@cinch-nx/shared-analytics'
import type { Vehicle } from '@cinch-nx/shared-types'

import styles from './cards.module.css'

interface VehicleCardProps {
  vehicle: Vehicle
  carouselName?: string
}

export const VehicleCard = ({ vehicle, carouselName }: VehicleCardProps) => {
  const { trackEvent } = useAnalytics()
  const handleClick = () => {
    trackEvent({
      eventName: `Car Rewiew - PDP Cards Latest Vehicle ${vehicle.make} ${vehicle.model}`,
      type: TrackingEventTypes.ADOBE,
      data: {
        event: {
          name: EventNames.click,
          category: `car review ${carouselName?.replace('-', ' ')}`,
          label: vehicle.vehicleId,
          action: 'Open',
        },
      },
    })
  }

  return (
    <div className={styles.vehicleCardContainer}>
      <SharedVehicleCard
        key={vehicle.vehicleId}
        id={vehicle.vehicleId}
        isSaved={false}
        isPending={vehicle.isReserved}
        isAvailable={vehicle.isAvailable}
        vehicle={vehicle}
        isSmallCardSize
        onCardClick={handleClick}
        isPersonalised={true}
      />
    </div>
  )
}

interface VehicleCardsListSlideProps {
  vehicles: Vehicle[]
  carouselName?: string
}

export const VehicleCardsList = ({
  vehicles,
  carouselName,
}: VehicleCardsListSlideProps) => (
  <ul className={styles.vehicleCardList} aria-label={carouselName}>
    {vehicles.map((vehicle) => (
      <li key={vehicle.vehicleId}>
        <VehicleCard
          key={vehicle.vehicleId}
          vehicle={vehicle}
          carouselName={carouselName}
        />
      </li>
    ))}
  </ul>
)
